module.exports = __webpack_public_path__ + "static/media/payment-icon3.a4d7d32a.svg";